module.exports = __webpack_public_path__ + "img/o2o07.6b0b5671.png";